// src/sections/HowWeWork/HowWeWork.tsx
import React from "react";
import choose_2 from "../../../assets/img/choose-2.jpg";
interface HowWeWorkProps {
  id: string;
}

const HowWeWork: React.FC<HowWeWorkProps> = ({ id }) => {
  return (
    <section id="how-we-work" className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h6 className="text-yellow-400 font-semibold text-lg">
                How We Work?
              </h6>
              <h2 className="text-2xl font-bold text-gray-900">
                Everything We Do is Measurable & Accountable
              </h2>
            </div>

            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Assessing your needs and pain points for allowing us to
                personalize high-performance plans of action.
              </p>
              <p>
                Our vibrant team works relentlessly to maintain mileposts and
                deliver on your product vision.
              </p>
              <p>
                Utilizing latest technologies to ensure efficient optimization
                of all resources during different levels of production/operation
                and during the launches of these products or services.
              </p>
              <p>
                We support our partner to unlock new ideas and help in scaling
                their businesses.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {["Discover", "KickOff", "Production and Launch", "Ramp up"].map(
                (phase, index) => (
                  <div
                    key={index}
                    className="group relative px-4 py-3 border-2 border-gray-300 rounded-lg cursor-pointer overflow-hidden transition-all duration-500"
                  >
                    {/* Progressive fill background - left to right */}
                    <div className="absolute inset-0 bg-purple-500 transform translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500 ease-out rounded-md"></div>
                    {/* Always-visible left border using pseudo-background */}
                    <div className="absolute top-0 left-0 h-full w-[4px] bg-[#7b68ee] z-10"></div>
                    {/* Border highlight on hover */}
                    <div className="absolute inset-0 border-2 border-transparent group-hover:border-purple-500 rounded-lg transition-colors duration-300"></div>

                    {/* Content */}
                    <div className="relative flex items-center gap-3 z-10">
                      <span className="text-gray-700 font-semibold group-hover:text-white transition-colors duration-300">
                        {phase}
                      </span>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          <div>
            <div>
              <img src={choose_2} alt="image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
